import { easyEstimatorApi } from '../easyEstimatorService';

import { ApiUrl } from '~/core/enums';
import { MaterialModel } from '~/core/models/material.model';

export type MaterialsQueryParams = {
  params?: { zipCode?: string; storeId?: number };
};

const materialsApi = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchMaterials: builder.query<MaterialModel[], MaterialsQueryParams>({
      query: ({ params }) => ({
        url: ApiUrl.MATERIALS,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useFetchMaterialsQuery } = materialsApi;
